import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CallbackComponent } from 'redux-oidc';
import { UserManager } from 'oidc-client';
import { LoadingAnimation } from '../controls/helpers';

export const Callback = ({ history, userManager } : RouteComponentProps & { userManager: UserManager }) =>
    <CallbackComponent userManager={userManager} successCallback={user => history.replace(user.state)} errorCallback={error => console.error(error)}>
        <LoadingAnimation />
    </CallbackComponent>

export const Signout = ({ userManager } : { userManager: UserManager }) => {
    useEffect(() => {
        userManager.signoutRedirect();
    }, []);
    return <LoadingAnimation />
}
